import React from "react";
import { IContextProvider } from "../../../uxp";
import { IQueryBuilderInstanceProps, IQueryBuilderProps } from "lucy/query-builder";
import { isComponentEnabled } from "../../../util";

// Query Builder
function isQueryBuilderComponentsLoaded() {
    return (typeof (window as any)?.QueryBuilderComponents !== 'undefined')
}

export async function isQueryEngineEnabled(uxpContext: IContextProvider) {
    try {
        const isEnabled = await isComponentEnabled(uxpContext, 'QueryEngine')
        return isEnabled
    }
    catch (e) {
        return false
    }
}

export async function isQueryEngineRunning(uxpContext: IContextProvider) {
    try {
        const res = await uxpContext.executeComponent('QueryEngine', '/status', 'get', {})
        return !!res
    }
    catch (e) {
        console.log('unable to check if query  engine is running or not')
        return false
    }
}

export type IQueryEngine = React.ForwardRefExoticComponent<React.RefAttributes<IQueryBuilderInstanceProps> & IQueryBuilderProps> | null

export async function getQueryBuilder(uxpContext: IContextProvider): Promise<IQueryEngine> {
    const isEnabled = await isQueryEngineRunning(uxpContext)
    console.log('Has_QB_____enabled', isEnabled, isQueryBuilderComponentsLoaded())

    if (isEnabled && isQueryBuilderComponentsLoaded()) {
        const { QueryBuilder } = (window as any).QueryBuilderComponents
        return QueryBuilder
    }
    return null
}

// Optional engine component: the reusable saved-query preview page exported by
// the query engine bundle (window.QueryBuilderComponents.QueryPreview). Older
// engine bundles predate it — callers must fall back to the built-in Stage-1
// preview when this returns null.
export function getQueryPreviewComponent(): React.ComponentType<any> | null {
    if (isQueryBuilderComponentsLoaded() && typeof (window as any)?.QueryBuilderComponents?.QueryPreview !== 'undefined') {
        return (window as any).QueryBuilderComponents.QueryPreview
    }
    return null
}